import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { DropdownModule } from 'primeng/primeng';

import { FilterHeaderComponent } from './filter-header/filter-header.component';
import { InformationComponent } from './information/information.component';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { CustomPaginationComponent } from './pagination/custom-pagination.component';

@NgModule({
  imports: [
    BrowserModule,
    CommonModule,
    DropdownModule,
    FormsModule,
    NgbPaginationModule,
    RouterModule,
    TranslateModule
  ],
  declarations: [
    CustomPaginationComponent,
    FilterHeaderComponent,
    InformationComponent,
    LoadingSpinnerComponent,
  ],
  exports: [
    CustomPaginationComponent,
    FilterHeaderComponent,
    InformationComponent,
    LoadingSpinnerComponent
  ],
  entryComponents: [InformationComponent]
})
export class CoreModule {}



// WEBPACK FOOTER //
// /opt/app/src/app/core/core.module.ts